import { render } from "./TopCreator.vue?vue&type=template&id=efda0808"
import script from "./TopCreator.vue?vue&type=script&lang=js"
export * from "./TopCreator.vue?vue&type=script&lang=js"

import "./TopCreator.vue?vue&type=style&index=0&id=efda0808&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__